import {
  InputFieldConfig,
  DerivedEventLegacy,
  type ActiveCohortBuilderItemLegacy,
  SimpleEventLegacy,
} from '@verantos-dev/types-cohorts';
import type { ConceptGroup } from '@verantos-dev/types-concepts';

import { SUBJECT_VARIABLE_FILTER_KEYS } from '../utils/filterTypes';
import {
  addOrMutateSubjectVariableFilters,
  reduceSubjectVariableConfigMap,
} from '../utils/subjectVariableUtils';

// The config map building is now handled by buildSubjectVariableConfigMap in buildConfigMap.ts

export const addSubjectVariable = (
  subjectVariable: ActiveCohortBuilderItemLegacy,
  simpleEvents: SimpleEventLegacy[],
  derivedEvents: DerivedEventLegacy[],
  conceptGroups: ConceptGroup[]
): ActiveCohortBuilderItemLegacy => {
  // Initialize or mutate the filters
  addOrMutateSubjectVariableFilters(subjectVariable);

  // Build the configMap for all filters
  const allConfigMaps = SUBJECT_VARIABLE_FILTER_KEYS.reduce(
    (acc, key) =>
      reduceSubjectVariableConfigMap(acc, key, {
        subjectVariable,
        simpleEvents,
        derivedEvents,
        conceptGroups,
      }),
    {} as Record<string, InputFieldConfig>
  );

  return {
    ...subjectVariable,
    inputFieldConfigMap: allConfigMaps,
  };
};
